<div class="tile-modal-container">
  <!-- Left Sidebar (Tile Options) -->
  <div class="tile-options">
    <mat-nav-list>
      <mat-list-item
        *ngFor="let tile of tileOptions"
        [class.active]="selectedTileType === tile.type"
        (click)="selectTileType(tile.type)">
        {{ tile.label }}
      </mat-list-item>
    </mat-nav-list>
  </div>

  <!-- Right Config & Preview Panel -->
  <div class="tile-config-preview">
    <div class="top-bar">
      <h2>{{ selectedTile?.label }} Preview</h2>
      <div *ngIf="saveErrorMessage != ''" class="error-text">{{saveErrorMessage}}</div>
      <!-- Action Button -->
      <div class="tile-modal-actions">
        <button mat-raised-button color="primary" (click)="saveTile()">Save</button>
      </div>
    </div>

    <!-- Preview Component -->
    <ng-container *ngIf="selectedTileOption">
      <ng-template #tileHost></ng-template>
    </ng-container>

    <!-- //Custom Config (per tile)
    <div class="tile-custom-config">
      // This section changes per tile type
      <ng-container [ngSwitch]="selectedTileType">
        <app-hero-tile-config *ngSwitchCase="'heroTile'" [(config)]="tileConfig"></app-hero-tile-config>
        <app-pie-chart-config *ngSwitchCase="'pieChartTile'" [(config)]="tileConfig"></app-pie-chart-config>
       // Add more as needed
      </ng-container>
    </div> -->
  </div>
</div>


